const normalizeUrl = (url = '') => url.replace(/\/$/, '').toLowerCase();

export const isWhiteLabelEnvironment = (
  currentLocation = window.location,
  skaleBotUrl = process.env.REACT_APP_SKALEBOT_APP_URL
) => {
  const currentOrigin = currentLocation?.origin;
  const currentHostname = currentLocation?.hostname;

  const isSkalebotDomain =
    !!skaleBotUrl && normalizeUrl(currentOrigin) === normalizeUrl(skaleBotUrl);
  const isLocalhost = currentHostname === 'localhost';

  return !isSkalebotDomain && !isLocalhost;
};
